import { AddressModel } from '../company/company.model';
export class ChangePasswordModel {
  email: string;
  currentPassword: string;
  newPassword: string;
}



export class MyProfile {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  extPhoneNumber: string;
  myProfileAddressModel: AddressModel;
  profileImagePath:string = '';
}

export class SelectedProfileImageModel {
  fileName: string;
  file: any;


  constructor(file: any, fileName: string) {
    this.file = file;
    this.fileName = fileName;
  }
}
